import styled from 'styled-components';

export const NavHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: self-start;
  @media (min-width: 500px) {
    align-items: center;
  }
`;

export const LogoImg = styled.img``;

export const LogoWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isOpen',
})`
  display: flex;
  flex-direction: column;

  ${(props) => props.isOpen && 'gap: 0.8rem;'}
`;

export const SunheroMotto = styled.p.withConfig({
  shouldForwardProp: (prop) => prop !== 'isOpen',
})`
  color: #00624f;
  font-family: DM-Sans;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: 0.15px;
  transition: all 0.3s ease-in-out;
  opacity: 0;
  max-height: 0;
  margin: 0;
  ${(props) => props.isOpen && 'opacity: 1; max-height: unset; margin: 1rem 0;'}
`;

export const CloseWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isOpen',
})`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
  @media (min-width: 500px) {
    margin-top: 0;
  }
  ${(props) =>
    props.isOpen &&
    `
  & span:nth-child(1) {
    transform: translateY(4px) rotate(45deg);
  }
  & span:nth-child(2) {
    transform: translateY(-10px) rotate(-45deg);
  }
  `}
`;

export const Line = styled.span`
  background-color: #00624f;
  width: 24px;
  height: 2px;
  opacity: 1;
  display: flex;
  margin: 0.375rem auto;
  transition: all 0.3s ease-in-out;
`;
